<template>
    <div class="overview" v-if="projectTokens.length > 0">
        <div :key="projectToken.id" v-for="(projectToken, index) in projectTokens" class="show-control">
            <elementary-section shadow :light="index % 2 === 0 ? false : true">
                <div class="container">
                    <div class="overview__header">
                        <h3 class="overview__title">{{ projectToken.title }}</h3>

                        <div class="overview__controls overview__controls--in-header z1">
                            <button @click="remove(projectToken)" iconic class="visible-on-overview-hover">
                                <span icon remove></span>Odstranit
                            </button>
                        </div>
                    </div>
                    <p class="overview__description" v-if="projectToken.bearer">
                        {{ projectToken.bearer }}
                    </p>
                </div>
            </elementary-section>
        </div>
    </div>
</template>

<script>
import ElementarySection from '@/components/Content/ElementarySection';

export default {
    name:       'ProjectTokenList',
    components: {ElementarySection},
    computed:   {
        projectTokens() {
            return this.$store.getters['projects/project/extension/projectToken/projectTokens'];
        }
    },
    methods:    {
        remove(projectToken) {
            const {id, title} = projectToken;
            this.$modal.show('dialog', {
                text:    'Opravdu chcete kód <strong>' + title + '</strong> odstranit?',
                buttons: [{
                    title:   'Zrušit',
                    handler: () => this.$modal.hide('dialog')
                }, {
                    title:   'Odstranit',
                    handler: () => {
                        this.$store.dispatch('projects/project/extension/projectToken/removeProjectToken', id)
                            .catch((message) => this.$dmv.notifyError(message));
                        this.$modal.hide('dialog');
                    }
                }]
            });
        },
    }
}
</script>
